import React from 'react';
import { useTranslation } from 'react-i18next';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { NavLink } from 'react-router-dom';
import path from '../../helpers/path';
import './PageSubHeaderLayout.css';

const pageSubHeaderClasses = getBEMClasses('page-sub-header');

const NavItems = [
  { text: 'Your Snapshot', path: '/dashboard' },
  { text: 'Market Data', path: '/dashboard/market-data' }
];

const PageSubHeaderComponent = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className={pageSubHeaderClasses('')}>
        {NavItems.map((link) => (
          <NavLink
            exact
            key={link.path}
            to={path(link.path)}
            className={pageSubHeaderClasses('item')}
            activeClassName={pageSubHeaderClasses('item', 'selected')}>
            {t(link.text)}
          </NavLink>
        ))}
      </div>
    </React.Fragment>
  );
};

export default PageSubHeaderComponent;
